<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm"
        @switchToOutTrailer="fnSwitchToOutTrailer"
      />
      <ImgInfoForm ref="imgInfoForm" />
      <ParametersForm ref="parametersForm" />
      <VehiclePictureForm ref="vehiclePictureForm" />
      <LocationForm ref="locationForm" />
      <CostInfoForm ref="costInfoForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import ImgInfoForm from './imgInfo';
import ParametersForm from './parameters';
import VehiclePictureForm from './vehiclePicture';
import LocationForm from './location';
import CostInfoForm from './costInfo';
import SubBtnBox from 'components/subBtnBox';
import {
  getTrailerVehicleLenth,
  getTrailerByTrailerId,
  doSaveOrUpdate,
} from 'api/car';
import {
  getEnumList,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    ImgInfoForm,
    ParametersForm,
    VehiclePictureForm,
    LocationForm,
    CostInfoForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/car/trailer/edit',
      formComponents: [
        'baseForm',
        'imgInfoForm',
        'parametersForm',
        'vehiclePictureForm',
        'costInfoForm',
        'locationForm',
        'costInfoForm',
      ],
      subLoading: false,

      // 需要对比的参数
      compareParams: {
        ext: {},
        trailer: {},
        trailerRel: {},
      },
    };
  },
  computed: {
    detailParams () {
      return {
        trailerId: this.$route.query.id,
      };
    },
    editParams () {
      return {
        isEdit: this.$route.query.id ? '2' : '1',
      };
    },
  },
  methods: {
    detailApi: getTrailerByTrailerId,
    editApi: doSaveOrUpdate,
    // 处理对比参数
    adjustCompareParams (compareParams, params) {
      if (compareParams.trailer) {
        compareParams.trailerNumber = compareParams.trailer.trailerNumber;
        compareParams.trailerMaterial = compareParams.trailer.trailerMaterial;
        compareParams.trailerLength = compareParams.trailer.trailerLength;
        compareParams.trailerLoad = compareParams.trailer.trailerLoad;
        compareParams.trailerVolume = compareParams.trailer.trailerVolume;
        compareParams.trailerType = compareParams.trailer.trailerType;
        compareParams.drivingLicenseId = compareParams.trailer.drivingLicenseId;
        compareParams.adriverLicenseCopyId = compareParams.trailer.adriverLicenseCopyId;
        compareParams.drivingLicenseDate = this.formatDate(compareParams.trailer.drivingLicenseDate);
        compareParams.vehicleValidityExpiredTime = this.formatDate(compareParams.trailer.vehicleValidityExpiredTime);
        compareParams.vinNo = compareParams.trailer.vinNo;
        compareParams.isState = compareParams.trailer.isState || '-1';
        compareParams.sourceProvince = compareParams.trailer.sourceProvince;
        compareParams.sourceRegion = compareParams.trailer.sourceRegion;
        compareParams.sourceCounty = compareParams.trailer.sourceCounty;
      }
      if (compareParams.ext) {
        compareParams['ext.vehicleBrand'] = compareParams.ext.vehicleBrand || '-1';
        compareParams['ext.brandModel'] = compareParams.ext.brandModel;
        compareParams['ext.axleNumber'] = compareParams.ext.axleNumber;
      }
      if (compareParams.trailerRel) {
        compareParams.trailerOwnerShip = compareParams.trailerRel.trailerOwnerShip || '-1';
        compareParams.purchaseDate = this.formatDate(compareParams.trailerRel.purchaseDate);
        compareParams.price = compareParams.trailerRel.price;
        compareParams.depreciatedMonth = compareParams.trailerRel.depreciatedMonth;
        compareParams.residual = compareParams.trailerRel.residual;
        compareParams.carRegistrationPicture = compareParams.trailerRel.carRegistrationPicture;
        compareParams.vehiclePicture = compareParams.trailerRel.vehiclePicture;
        compareParams.vehicleClass = compareParams.trailerRel.vehicleClass;
      }
    },
    // 根据挂车种类，切换各个表单的显示隐藏
    fnSwitchToOutTrailer (vehicleClass) {
      for (let item of this.formComponents) {
        if (this.$refs[item].receivedData) {
          this.$refs[item].receivedData(vehicleClass);
        }
      }
    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'OWNER_SHIP,TRAILER_MATERIAL,TRAILER_TYPE,VEHICLE_BRAND,VEHICLE_LENGTH,VEHICLE_LENGTH,TRAILER_VEHICLE_CLASS',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    const vehicleLenth = await getTrailerVehicleLenth();
    const vehicleLenthOptions = Array.isArray(vehicleLenth) ? vehicleLenth : [];
    const trailerLengthOptions = [{
      label: '请选择',
      value: '-1',
    }, ...vehicleLenthOptions];
    const trailerMaterialOptions = [{
      label: '请选择',
      value: '-1',
    }, ...safeEnum(1)];
    const isStateOptions = [{
      label: '请选择',
      value: '-1',
    }, ...safeEnum(2)];
    const vehicleBrandOptions = [{
      label: '请选择',
      value: '-1',
    }, ...safeEnum(3)];
    const vehicleClassOptions = [
      ...safeEnum(6),
    ];
    if (this.$refs.costInfoForm) {
      this.$refs.costInfoForm.setList([{ label: '请选择', value: '-1' }, ...safeEnum(0)]); // 车辆性质
    }
    this.$refs.baseForm && this.$refs.baseForm.setList([trailerMaterialOptions, trailerLengthOptions, vehicleClassOptions]); // 挂车材质,挂车车长,挂车种类
    this.$refs.locationForm && this.$refs.locationForm.setList(isStateOptions);
    this.$refs.parametersForm && this.$refs.parametersForm.setList(vehicleBrandOptions);
    this.getData();
  },
};
</script>

<style>
</style>
